import type { Components, Theme } from '@mui/material';

export const MuiListItemButton: Components<Theme>['MuiListItemButton'] = {
  styleOverrides: {
    root: {
      gap: 'var(--ListItem-gap)',
    },
  },
};
